module.exports = __webpack_public_path__ + "img/tixian1.0a225099.png";